import * as CONST from '../utils/constants';
import Util from '../utils/ui';
import Stepper from '../stepper';
//import datepicker from 'js-datepicker';

class Common {
	constructor() {
		this.categories = [];
		this.stepper = document.getElementById('stepper');
		this.questionnaireId = parseInt(this.stepper.dataset.questionnaireid);
	}

	init() {
		this.bindEvents();

		this.getQuestions();
		
	}

	bindEvents() {
		//const picker = datepicker('.date-picker');
	}

	getQuestions() {
		fetch(`${window.lhfs.ApiBaseUrl}/Questionnaire?id=${this.questionnaireId}`)
			.then((response) => {
				return response.json();
			})
			.then((data) => {
				this.categories = data.categories;
				this.initStepper();
			})
			.catch((error) => console.log(error));
	}

	initStepper() {
		let stepper = new Stepper(this.stepper, {
			formActionUrl: `${window.lhfs.ApiBaseUrl}/Questionnaire/participants`,
			singleQuestions: true,
			transition: 'slide',
			submitBtn: 'Submit',
			thankYouSlide: true,
			thankYouTitle: 'Thank You!',
			thankYouText: 'Thank you for submitting your information to Land Home Financial Services, Inc.  We will be reviewing it shortly and a Loan Officer will contact you within 1-2 business days.',	
			json: { // json data and [key] names
				data: this.categories,
				categoryId: 'id',
				prerequisiteID: 'prerequisiteQuestionId',
				prerequisiteValue: 'prerequisiteValue',
				prerequisites: 'prerequisites',
				hasPrerequisite: 'hasPrerequisite',
				regexValidation: 'regexValidation',
				questionArray: 'questions',
				questionId: 'id',
				isOptional: 'isOptional',
				required: 'required',
				questionText: 'content',
				questionType: 'questionType',
				answerOptions: 'answers',
				answerOptionsText: 'label',
				answerOptionsValue: 'id',
				skipFormSubmit: 'skipSubmit'
			},
			questionTypes: {
				Unknown: 'Unknown',
				TrueFalse: 'TrueFalse',
				TextEntry: 'TextEntry',
				TextAreaEntry: 'TextAreaEntry',
				NumberEntry: 'NumberEntry',
				DateEntry: 'DateEntry',
				DollarEntry: 'DollarEntry',
				OptionSelect: 'OptionSelect',
				Terminator: 'Terminator',
				StateSelect: 'StateSelect',
				CountySelect: 'CountySelect'
			},
		});

		let category = {
			'id': 9999,
			'name': 'Personal Information',
			'prerequisiteQuestionId': null,
			'prerequisiteValue': null,
			'hasPrerequisite': false,
			'questions': [
				{
					'id': 9991,
					'answers': [],
					'content': 'First Name',
					'prerequisiteQuestionId': null,
					'prerequisiteValue': null,
					'sortOrder': 1,
					'questionType': 'TextEntry',
					'hasPrerequisite': false
				},
				{
					'id': 9992,
					'answers': [],
					'content': 'Last Name',
					'prerequisiteQuestionId': null,
					'prerequisiteValue': null,
					'sortOrder': 2,
					'questionType': 'TextEntry',
					'hasPrerequisite': false
				},
				{
					'id': 9993,
					'answers': [],
					'content': 'Street Address',
					'prerequisiteQuestionId': null,
					'prerequisiteValue': null,
					'sortOrder': 3,
					'questionType': 'TextEntry',
					'hasPrerequisite': false
				},
				{
					'id': 9994,
					'answers': [],
					'content': 'City',
					'prerequisiteQuestionId': null,
					'prerequisiteValue': null,
					'sortOrder': 4,
					'questionType': 'TextEntry',
					'hasPrerequisite': false
				},
				{
					'id': 9995,
					'answers': [],
					'content': 'State',
					'prerequisiteQuestionId': null,
					'prerequisiteValue': null,
					'sortOrder': 5,
					'questionType': 'StateSelect',
					'hasPrerequisite': false
				},
				{
					'id': 9996,
					'answers': [],
					'content': 'Zip',
					'prerequisiteQuestionId': null,
					'prerequisiteValue': null,
					'sortOrder': 6,
					'questionType': 'TextEntry',
					'hasPrerequisite': false,
					'regexValidation': 'zipcode'
				},
				{
					'id': 9997,
					'answers': [],
					'content': 'Phone',
					'prerequisiteQuestionId': null,
					'prerequisiteValue': null,
					'sortOrder': 7,
					'questionType': 'TextEntry',
					'hasPrerequisite': false,
					'regexValidation': 'phone'
				},
				{
					'id': 9998,
					'answers': [],
					'content': 'Email',
					'prerequisiteQuestionId': null,
					'prerequisiteValue': null,
					'sortOrder': 8,
					'questionType': 'TextEntry',
					'hasPrerequisite': false,
					'regexValidation': 'email'
				},
				{
					'id': 9999,
					'answers': [],
					'content': 'Would you like to be contacted by Land Home Financial Services?',
					'prerequisiteQuestionId': null,
					'prerequisiteValue': null,
					'sortOrder': 9,
					'questionType': 'TrueFalse',
					'hasPrerequisite': false,
				},
			]
		}

		stepper.addCategory(category);

		stepper.init();
	}
}

export default Common;